import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ColorList } from 'app/bars/topbar/topbarData';
import { ItemExtra, NewTask } from '../tasksData';
import { CasePriority } from 'app/settings/category-setup/category-setup.component';
import { ActivityType } from 'app/activities/activities';
import * as api from '../../shared/api/apihandler';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { FileFunctions } from 'app/shared-html-components/case-files/case-files-functions';
import { CaseFunctions } from 'app/details-new/caseFunctions';
import { GetOffer } from 'app/shared-html-components/document-creator/productGrid';
import { PropertyById } from 'app/shared/models/property.models';
import { RuleList, Rule } from 'app/settings/templatemanager/templatemanager.component';
import { ActionService } from 'app/shared/services/action.service';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { UserService } from 'app/shared/services/user.service';
import { addHours, format } from 'date-fns';
import { Dates } from 'app/shared/utilities/shared.functions';
import { DateUtilities } from 'app/shared/utilities/dateUtilities'; 
import { Subscription } from 'rxjs';

@Component({
  selector: 'new-task-slider',
  templateUrl: './new-task-slider.component.html',
  styleUrls: ['./new-task-slider.component.css']
})
export class NewTaskSliderComponent implements OnInit, OnChanges {
  @Input() caseId: string;
  @Input() offerId: string;
  @Input() propertyId: string;
  @Input() template: boolean = false;
  @Input() attachable:boolean = false;
  @Input() service: boolean = false;
  @Output() newItemEvent = new EventEmitter<boolean>();
  fileApi = new FileFunctions(this.http);
  caseApi = new CaseFunctions(this.http);
  item: NewTask = new NewTask();
  itemExtraInfo: ItemExtra = new ItemExtra();
  companyInfo;
  dueTimes = Dates.dueTimes; 
  durationTimes = Dates.durationTimes;
  bsConfig = DateUtilities.bsConfig;
  dueDate: Date | null = null;
  dueTime: string | null = null;
  duration: string | null = '01:00';
  priorities: Array<CasePriority>;
  activityTypes: ActivityType[];
  users: Array<User>;
  selectedUserId: string | null;
  showRecurring: boolean = false;
  showUsers: boolean = false;
  errorText: string = '';
  files = [];
  ruleList: Array<RuleList>;
  selectedRules: Array<SelectedRule> = [];
  templateStep: number = 1;
  ruleIndex: number = 0;
  taurus: boolean = false;
  subs: SubscriptionObject = {};
  caseDesc?: string;
  caseTitle?: string;

  constructor(private sharedData: SharedDataService, private http: HttpClient, private translate: TranslateService, private route: ActivatedRoute, private actionService: ActionService, private user: UserService) { }

  ngOnInit(): void {
    this.subs['priorities'] = this.sharedData.priorities().subscribe(data => { 
      this.priorities = data.sort((a,b) => {
        if(!a.sortOrder) return -1;
        if(!b.sortOrder) return -1;
        return a.sortOrder - b.sortOrder;
      });
    }) as Subscription;
    this.selectedUserId = localStorage.getItem('bearer');
    this.subs['companyUsers'] = this.sharedData.companyUsers().subscribe(data => this.users = data.sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
    this.subs['companyInformation'] = this.sharedData.companyInformation().subscribe(data => { 
      this.companyInfo = data;
      this.taurus = data.id == '2605daad-d63b-4ccb-9c35-bce53c4becd4' ? true : false;
    });
    this.preparation(false);
    if (!!this.propertyId)  this.getInfo('property');
    else if (!!this.offerId) this.getInfo('offer');
    else if (!!this.caseId) this.getInfo('case');
    this.actionService.taskSubject.subscribe({
      next: (data) => {
        if (!!data) {
          this.item = data;
        }
      },
      error: err => console.error(err)
    })    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.template) {
      this.getTemplates();
    }
    if (!!changes.caseId && !!changes.caseId.currentValue && changes.caseId.currentValue != changes.caseId.previousValue && !this.offerId) {
      this.getInfo('case');
    }
    if (!!changes.offerId && !!changes.offerId.currentValue && changes.offerId.currentValue != changes.offerId.previousValue) {
      this.getInfo('offer');
    }
    if (!!changes.propertyId && !!changes.propertyId.currentValue && changes.propertyId.currentValue != changes.propertyId.previousValue) {
      this.getInfo('property');
    }
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  openModal() {
    const modal = document.getElementById('newTaskItemSliderModal');
    modal.addEventListener('click', () => { 
      setTimeout(() => {
        if (modal.style.display == 'none') {
          this.template = false;
        }
      }, 200);
    });
  }

  getInfo(type: string) {
    switch (type) {
      case 'case':
        this.caseApi.getCase(this.caseId).subscribe({
          next: (caseData: any) => {
            this.item.customerId = caseData?.customer?.customerId;
            this.item.customerName = caseData?.customer?.name;
            this.caseDesc = caseData?.description + (!!caseData.requisitionNumber ? '\nRekv. nr.: ' + caseData.requisitionNumber : '');
            this.caseTitle = caseData?.title;
            let where = !!caseData && !!caseData.delivery ? caseData.delivery : (!!caseData && !!caseData.customer ? caseData.customer : (!!caseData && !!caseData.invoice ? caseData.invoice : null));
            let extraType = !!this.itemExtraInfo.type && this.itemExtraInfo.type != '' ? this.itemExtraInfo.type : 'case';
            let number = !!this.itemExtraInfo.number && this.itemExtraInfo.number != '' ? this.itemExtraInfo.number : (!!caseData.caseNumber ? caseData.caseNumber : '');
            this.setExtraInfo(extraType, where.name, where.address, number, null, caseData.responsibleId);
          },
          error: err => console.error(err)
        });
        break;
      case 'offer':
        this.caseApi.getOffer(this.offerId).subscribe({
          next: (offerData: GetOffer) => {
            this.item.customerId = offerData.customerId;
            this.item.customerName = offerData.overview.name;
            this.caseId = offerData.caseId;
            this.setExtraInfo('offer', offerData.overview.name, offerData.overview.address, offerData.overview.offerNumber, null, offerData.responsible.key);
          },
          error: err => console.error(err),
          complete: () => { this.getInfo('case'); }
        });
        break;
    }
  }

  setExtraInfo(type: string, name: string, address: string, number: string, image: string, responsible: string) {
    this.itemExtraInfo.type = type;
    this.itemExtraInfo.address = name;
    this.itemExtraInfo.name = address;
    this.itemExtraInfo.number = number;
    this.itemExtraInfo.image = image;
    this.itemExtraInfo.responsible = responsible;
    if (this.taurus && this.service) {
      this.item.activityType = '2fbd2abb-bc27-4a20-a4f9-72e8f4253ff3';
    } else if (this.taurus && !this.service) {
      this.item.activityType = '3826867e-4803-46cd-ab7b-7a6b8715e103';
    }
  }

  preparation(reset: boolean) {
    this.item = new NewTask();
    this.dueDate = new Date();
    let time = format(addHours(new Date(),1),"HH:mm");
    time = time.split(':')[0] + ':00';
    this.dueTime = time;
    if (!reset) {
      this.item.assignedToStakeholder = localStorage.getItem('bearer');
      this.getActivityTypes();
    }
  }

  getActivityTypes() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<ActivityType[]>(api.jubloApi + 'api/Activity/ActivityTypes', { headers }).subscribe({
      next: (data) => { this.activityTypes = data.sort((a,b)=>{
        if(!a.name || !b.name) return !a.name ? 1 : -1;
        a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    }) }
    });
  }

  getTemplates() {
    //console.log('getting templates');
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<RuleList>>(api.jubloApi + 'api/Activity/GetRuleLists', { headers }).subscribe({
      next: data => this.ruleList = data,
      error: err => console.error(err),
      complete: () => {
        this.ruleList.forEach(x => {
          x.rules.forEach(y => {
            y.activityType = y.activityTypeId;
            delete y.activityTypeId;
          })
        });
        this.ruleIndex = 0;
      }
    });
  }

  selectRule(listId: string, rule: SelectedRule) {
    console.log('rule selected?')
    if (!!this.selectedRules && !!this.selectedRules.find(x => x.id == rule.id && x.listId == listId)) {
      this.selectedRules = this.selectedRules.filter(x => x.id != rule.id && x.listId != listId);
    } else {
      rule.hidden = true;
      rule.ready = false;
      rule.dueDate = new Date();
      rule.dueTime = '08:00';
      rule.durationInMinutes = 1
      rule.assignedToStakeholder = this.itemExtraInfo.responsible;
      rule.listId = listId;
      rule = { ...new SelectedRule(), ...rule };
      this.selectedRules.push(rule);
    }
  }

  checkReadyState() {
    for (let x of this.selectedRules) {
      if (!x.ready) return false;
    }
    return true;
  }

  checkRequiredFields() {
    let r = this.selectedRules.find(x => !x.hidden);
    if (!!r && !!r.description && !!r.dueDate && !!r.dueTime && !!r.durationInMinutes && !!r.assignedToStakeholder) {
      return false;
    } else {
      return true
    }
  }

  setReady() {
    let r = this.selectedRules.find(x => !x.hidden);
    if (!!r) {
      r.ready = true;
      r.hidden = true;
    }
    if (this.selectedRules.length > this.ruleIndex + 1) {
      this.ruleIndex = this.ruleIndex + 1;
      this.selectedRules[this.ruleIndex].hidden = false;
    }
  }

  openRule(i: number) {
    this.selectedRules.forEach(x => {
      x.hidden = true;
    });
    this.selectedRules[i].hidden = false;
    this.selectedRules[i].ready = false;
  }

  createNewTask() {
    if (this.item.subject == '') {
      this.errorText = this.translate.instant('ErrorMessage.Title');
    } else if (this.item.description == '') {
      this.errorText = this.translate.instant('ErrorMessage.Description');
    } else if (!this.item.activityType) {
      this.errorText = this.translate.instant('ErrorMessage.Type');
    } else {
      this.item.caseId = !!this.item.caseId ? this.item.caseId : this.caseId;
      this.item.offerId = !!this.item.offerId ? this.item.offerId : this.offerId;
      this.item.propertyId = !!this.item.propertyId ? this.item.propertyId : this.propertyId;
      this.updateTask();
    }
  }

  asDate(date:string){
    return !!date ? new Date(date) : null
  }

  setDueDate(date:Date | null, item){
    this.item.dueDate = !!date ? date.toISOString() : null
  }

  changeDueDate(ev:Date | null){
    if(!!ev){
      this.dueDate = ev;
      let date = this.dueDate.toISOString().split('T')[0];
      if(this.dueTime){
        const timeParts = this.dueTime.split(':').map(part => parseInt(part, 10));
        const hours = timeParts[0];
        const minutes = timeParts[1];

        const mergedDateTime = new Date(this.dueDate.getTime()); // Make sure no weird date conversion happens.
        mergedDateTime.setHours(hours, minutes, 0, 0);

        this.item.dueDateTime = mergedDateTime.toISOString();
      }
    }
  }

  updateTask() {
    let date;
    if (!!this.dueDate) {
      date = this.dueDate.toISOString().split('T')[0];
      this.item.dueDateTime = date + 'T00:00:00Z';
    } else {
      this.item.dueDateTime = null;
    }
    if (!!this.duration) {
      this.item.durationInMinutes = +((+this.duration.slice(0, 2) * 60) + (+this.duration.slice(-2)));
    }
    console.log('creating new task with data:', this.item);
    this.saveTask();
  }

  createTasksFromTemplate() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    for (let x of this.selectedRules) {
      delete x.activityTypeId;
      x.propertyId = this.propertyId;
      x.durationInMinutes = !!x.durationInMinutes ? x.durationInMinutes * 60 : 60;
      x.dueDateTime = x.dueDate.toISOString().slice(0,11) + x.dueTime;
      
      this.http.post(api.jubloApi + 'api/Activity', x, { headers }).subscribe({
        next: (data: string) => { console.log(data) },
        error: err => console.error(err),
        complete: () => {
          this.preparation(true);
          this.newItemEvent.emit(true);
          document.getElementById('newTaskItemSliderModalCloseBtn').click();
        }
      });
    }
  }

  saveTask() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Activity', this.item, { headers }).subscribe({
      next: (data: string) => {
        //console.log('task saved', this.files, this.files.length, data);
        if (this.files.length) this.sendFilesToTask(data);
      },
      error: err => console.error(err),
      complete: () => {
        this.preparation(true);
        this.newItemEvent.emit(true);
        document.getElementById('newTaskItemSliderModalCloseBtn').click();
      }
    });
  }

  sendFilesToTask(taskId: string) {
    let count = 0;
    for (let file of this.files) {
      this.fileApi.fileToTask(file.fileId, taskId).subscribe({
        next: () => count += 1,
        error: (err) => { console.warn("File couldn't be attached to task", file, err); count += 1 },
        complete: () => {
          if (count == this.files.length) this.files = [];
        }
      })

    }
  }

  changeUser() {
    this.selectedUserId = !this.selectedUserId || this.selectedUserId == 'null' ? null : this.selectedUserId;
    this.item.assignedToStakeholder = this.selectedUserId;
    this.showUsers = false;
  }

  makeRecurrance() {
    this.item.recurrance = 'RRULE:FREQ=DAILY;INTERVAL=7;WKST=MO';
    this.showRecurring = true;
  }

  recurrangeChange(event) {
    if (event == null) {
      this.showRecurring = false;
      this.item.recurrance = null;
    } else if (typeof event === 'string' && event.startsWith('RRULE')) {
      this.item.recurrance = event;
    }
  }

  openShowUsers() {
    this.showUsers = !this.showUsers;
    if (this.showUsers) {
      setTimeout(() => {
        document.getElementById('showUsers').getElementsByTagName('input')[0].focus();
      }, 200);
    } else {
      this.item.assignedToStakeholder = this.selectedUserId;
    }
  }

  findUser() {
    if (!!this.users) {
      return this.users.find(x => x.userId == this.selectedUserId).name;
    } else {
      return '';
    }
  }

  findColor(type) {
    if (!!this.selectedUserId && !!this.users) {
      let responsible = !!this.selectedUserId ? this.users.find(x => x.userId == this.selectedUserId).name.trim() : '';
      
      // let responsible = !!this.selectedUserId ? this.users.find(x => x.userId == this.selectedUserId).name.trim().substring(0, 1).toUpperCase() : '';
      if (responsible != '') {
        let init = responsible.trim().substring(0, 1).toUpperCase();
        switch (type) {
          case 'name' : return this.user.getInitials(responsible);
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#80b8f2';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      }
      else return ''
    }
  }

  findInitial(s:string){
    if(!s || !s.replace(/[^a-zA-Z]/g, '').length) return ''
    return s.replace(/[^a-zA-Z]/g, '')[0].toUpperCase()
  }

  imgDrop(files) {
    if (files.length > 0) {
      for (let f of files) {
        this.fileApi.uploadFile(f).subscribe({
          next: (data) => this.files.push(data),
          error: (err) => console.warn('File upload failed')
        })

      }
    }
  }

  openSearchModal(id:string){
    let a = document.getElementById(id);
    a.click()
  }

  attachTo(to:string, ev:any){
    this.item.offerId = null;
    this.item.caseId = null;
    this.item.propertyId = null;
    this.item.propertyLeaseId = null;
    this.item.customerId = null;
    this.item.customerName = null;
    console.log(to, ev)
    switch(to){
      case 'document': {
        this.item.offerId = ev.offerId;
        this.item.customerId = ev.customerId;
        this.item.customerName = ev.customer?.name;
        break;
      }
      case 'case':{
        this.item.caseId = ev.caseId;
        this.item.customerId = ev.customer?.customerId;
        this.item.customerName = ev.customer?.name;
        break;
      }
      case 'property':{
        this.item.propertyId = ev.id;
        this.item.customerName = ev.name;
        break;
      }
      case 'lease':{
        this.item.propertyId = ev.property?.id;
        this.item.propertyLeaseId = ev.id;
        this.item.customerName = ev.leaseNumber;
        break;
      }
      case 'customer':break;
    }
    console.log(this.item)
  }
}

export class User {
  address: string;
  city: string;
  email: string;
  externalId: string;
  image: string;
  isAdmin: boolean;
  mobileCountryCode: string;
  mobileNumber: string;
  name: string;
  radius: string;
  skills: [];
  userId: string;
  zipCode: string;
}

class SelectedRule extends Rule {
  selected?: boolean = false;
  listId: string | null = null;
  hidden: boolean = true;
  ready: boolean = false;
  dueDate: Date | null = null;
  dueTime: string | null = null;
  dueDateTime: string | null = null;
  durationInMinutes: number = 0;
  recurring: number = 0;
  recurrance: string | null = null;
  assignedToStakeholder: string | null = null;
  status: string | null = '7cb83847-96ee-4567-8555-b9d770ff16c0';
  customerId: string | null = null;
  caseId: string | null = null;
  offerId: string | null = null;
  propertyId: string | null = null;
  propertyLeaseId: string | null = null;
  templateId: string | null = null;
  note: string | null = null;
  dvCategoryId: string | null = null;
  dvAccountPlanId: string | null = null;
  mandatory: boolean = false
  partnerCompanyId: string | null = null;
  priorityId: string | null = null;
}
